import React from 'react'
import injectStyles from 'react-jss'

import { Col, Row, Badge } from 'react-bootstrap'
import Form, { Dropzone } from 'Components/Form'
import { SectionLabel } from 'Components/Section/SectionLabel/index'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'

import { styles } from './styles'

const UploadDocumentItem = ({
  itemData,
  classes,
  onUploadDocument,
  onSubmit,
}) => (
  <div>
    <Form
      onSubmit={() =>
        onSubmit({
          typeId: itemData.id,
        })
      }
    >
      <div className={classes.title}>{itemData.name}</div>
      <SectionLabel>{itemData.instructionText}</SectionLabel>
      <Row xs={9} className={classes.row}>
        <Col xs={3} className={classes.col}>
          <Dropzone
            name="upload-document"
            input={{
              value: itemData.documentPreview,
              onChange: file => onUploadDocument({ file, typeId: itemData.id }),
            }}
            meta={{}}
            disabled={itemData.isDisableDropzone}
            accept={'application/pdf, image/*'}
          />
          {itemData.documentPreview ? (
            <p className={classes.info}>
              If the file preview is not available but the status is complete,
              it is already loaded in PDF format.
            </p>
          ) : null}
        </Col>
        <Col xs={3}>{itemData.loading ? <LoadingIndicator /> : null}</Col>
        <Col xs={3}>
          {itemData.documentPreview ? (
            <Badge className={classes.success}>Success</Badge>
          ) : (
            <Badge className={classes.error}>Required</Badge>
          )}
        </Col>
      </Row>
    </Form>
  </div>
)

export default injectStyles(styles)(UploadDocumentItem)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/UploadDocuments/UploadDocumentsForm/UploadDocumentItem/index.js